import React, { useState, useRef, useEffect } from "react";
import Cookies from "js-cookie";
import NavBar from "../../../Navbar/Navbar";
import { setEnvironmentColors } from "../../../Utils/EnvironnementColor";
import { getModel } from "../../../../API/modelList";
import fetchModel from "../../../../AdminAPI/ModelADM";
import { VideoCodage } from "../../../../API/VideoCodage";
import { getDocByStatus } from "../../../../API/DocByStatus";
import { getDocByStatusADM } from "../../../../AdminAPI/DocByStatusADM";
import { docUpdate } from "../../../../API/docUpdate";
import { parseCustomDate } from "../../../Utils/DateManager";
import { toggleSort, applySort } from "../../../Utils/SortManager";
import { applyFilters } from "../../../Utils/FiltersManager";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSortUp, faSortDown } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
import Modal from "react-modal";
import "../TabLots/LotsTable.css";
import "./ModelsVideoCodage.css";

const ModelsVideoCodage = () => {
  const [colorFilter, setcolorFilter] = useState("#235073");
  const [colorFilterAction, setcolorFilterAction] = useState("#ffffff");
  const [modelsData, setModelsData] = useState([]);
  const [sortField, setSortField] = useState("oldestDocDate");
  const [sortOrder, setSortOrder] = useState("asc");
  const [filteredData, setFilteredData] = useState([]);
  const [modalIsOpen1, setModalIsOpen1] = useState(false);
  const [currentReviewURL, setCurrentReviewURL] = useState("");
  const [currentDocName, setCurrentDocName] = useState("");
  const [currentInstanceId, setCurrentInstanceId] = useState("");
  const instanceIdRef = useRef(null);
  const docNameRef = useRef(null);
  const [clientOptions, setClientOptions] = useState([]);
  const [filter, setFilter] = useState({
    ModelId: "",
    statusFilter: "",
    client: "",
  });
  const role = Cookies.get("Role");
  const idToken = Cookies.get("Token");
  const { t } = useTranslation();

  useEffect(() => {
    const loadModelsWithDocs = async () => {
      try {
        let modelList;
        if (role === "superadmin") {
          modelList = await fetchModel(null, idToken);
          console.log(modelList)
        } else {
          modelList = await getModel(idToken);
        }
        if (!modelList || !Array.isArray(modelList)) {
          throw new Error("modelList is undefined or not an array");
        }

        const modelsWithDocs = await Promise.all(
          modelList.map(async (model) => {
            const statuses = model.VideoCodageStatus || [];
            const docsByStatus = await Promise.all(
              statuses.map(async (status) => {
                let docs;
                if (role === "superadmin") {
                  docs = await getDocByStatusADM(
                    status,
                    model.ModelId,
                    null,
                    idToken
                  );
                } else {
                  docs = await getDocByStatus(idToken, status, model.ModelId);
                }
                const validDates = (docs || [])
                  .map((doc) => parseCustomDate(doc.LastUpdate))
                  .filter((date) => date !== null && !isNaN(date));
                const oldestDocDate =
                  validDates.length > 0
                    ? validDates.reduce((oldest, current) =>
                        current < oldest ? current : oldest
                      )
                    : null;
                return {
                  status,
                  docs,
                  docsCount: docs.length,
                  oldestDocDate,
                };
              })
            );
            return {
              ...model,
              docsByStatus,
            };
          })
        );

        const clientsSet = new Set();
        modelsWithDocs.forEach((model) => {
          model.docsByStatus.forEach((statusData) => {
            (statusData.docs || []).forEach((doc) => {
              if (doc.ClientId) clientsSet.add(doc.ClientId);
            });
          });
        });

        setClientOptions([...clientsSet]);
        setModelsData(modelsWithDocs);
      } catch (error) {
        console.error(
          "Erreur lors du chargement des modèles ou documents :",
          error
        );
      }
    };

    loadModelsWithDocs();
    const intervalId = setInterval(loadModelsWithDocs, 60000);
    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    setEnvironmentColors([
      [setcolorFilter, "colorFilter"],
      [setcolorFilterAction, "colorFilterAction"],
    ]);
  }, []);

  const handleSort = (field) => {
    toggleSort(field, sortField, setSortField, sortOrder, setSortOrder);
  };

  useEffect(() => {
    const filtered = applyFilters(modelsData, filter);
    const sorted = applySort(filtered, sortField, sortOrder);
    setFilteredData(sorted);
  }, [modelsData, filter, sortField, sortOrder]);

  useEffect(() => {
    handleSort("oldestDocDate");
  }, []);

  const VideoCodageButton = async (ModelId, status) => {
    try {
      const data = await VideoCodage(idToken, status, ModelId, "in_review");
      if (data.message.reviewURL) {
        openModal1(
          data.message.reviewURL,
          ModelId,
          data.message.DocumentId,
          data.message.InstanceId
        );
      }
    } catch (error) {
      console.error("Erreur lors de l'appel VideoCodage :", error);
    }
  };

  const openModal1 = (reviewURL, ModelId, docName, instanceId) => {
    setCurrentReviewURL(`${reviewURL}&displayMode=iframe`);
    setCurrentDocName(docName);
    setCurrentInstanceId(instanceId);
    instanceIdRef.current = instanceId;
    docNameRef.current = docName;
    setModalIsOpen1(true);
  };

  const closeModal1 = () => {
    setModalIsOpen1(false);
  };

  const receiveIframeMessage = async (event) => {
    if (
      event.data?.target === "parent" &&
      event.data.eventName === "ManualReviewWasPaused"
    ) {
      await handleTaskStatusUpdate("suspending");
    }
  };

  const handleTaskStatusUpdate = async (status) => {
    try {
      await docUpdate(
        idToken,
        instanceIdRef.current,
        docNameRef.current,
        "normal",
        1,
        true,
        status
      );
    } catch (error) {
      console.error("Erreur lors de la mise à jour du statut :", error);
    }
  };

  useEffect(() => {
    window.addEventListener("message", receiveIframeMessage);
    return () => {
      window.removeEventListener("message", receiveIframeMessage);
    };
  }, []);

  const allStatuses = [
    ...new Set(modelsData.flatMap((m) => m.docsByStatus.map((s) => s.status))),
  ];
  const uniqueModels = [...new Set(modelsData.map((m) => m.ModelId))];

  return (
    <>
      <NavBar />
      <div
        id="video-codage-page-container"
        className="page-container"
        style={{
          backgroundColor: "#F7F9F9",
          padding: 0,
          margin: 0,
          minHeight: "95vh",
        }}
      >
        <div id="video-codage-header-container">
         
          <div id="video-codage-title-block">
            <h1
              id="video-codage-title"
              style={{
                fontSize: "28px",
                fontWeight: "600",
                fontFamily: "Segoe UI, Tahoma, Geneva, Verdana, sans-serif",
                display: "flex",
                alignItems: "center",
                gap: "10px",
                margin: 0,
              }}
            >
              <i className="fas fa-video" style={{ color: "black" }}></i>
              {t("models video coding")}
            </h1>
            <div
              id="video-codage-title-line"
              style={{
                height: "4px",
                width: "150px",
                borderRadius: "2px",
                background: "linear-gradient(90deg, steelblue, lightsteelblue)",
              }}
            />
          </div>

        
        {role === "superadmin" && (
            <div id="video-codage-client-select-container">
            <select
                id="video-codage-client-select"
              value={filter.client}
                onChange={(e) =>
                  setFilter({ ...filter, client: e.target.value })
                }
              className="client-select"
            >
              <option value="">{t("Client")}</option>
              {clientOptions.map((client) => (
                <option key={client} value={client}>
                  {client}
                </option>
              ))}
            </select>
              <button
                id="video-codage-reset-btn"
                className="btn btn-danger btn-reinit"
                onClick={() =>
                  setFilter({ client: "", ModelId: "", statusFilter: "" })
                }
              >
                {t("Reset")}
              </button>
          </div>
          )}
        </div>

        <div className="table-responsive style_table_responsive">
          <div
            style={{
              height: "600px",
              overflowY: "auto",
              margin: 0,
              padding: 0,
            }}
          >
            <table
              className="table table-striped"
              style={{ lineHeight: 1, margin: 0, padding: 0 }}
            >
              <thead className="style_thead">
                <tr
                  className="style_thead_tr"
                  style={{ backgroundColor: colorFilter }}
                >
                  <th
                    style={{
                      width: "150px",
                      backgroundColor: "inherit",
                      color: "white",
                    }}
                  >
                    {t("Models")}
                  </th>
                  <th
                    style={{
                      width: "150px",
                      backgroundColor: "inherit",
                      color: "white",
                    }}
                  >
                    {t("Status")}
                  </th>
                  <th
                    style={{
                      width: "150px",
                      backgroundColor: "inherit",
                      color: "white",
                      cursor: "pointer",
                    }}
                    onClick={() => handleSort("docsCount")}
                  >
                    {t("Number of docs in VideoCoder")}
                    {sortField === "docsCount" && (
                      <FontAwesomeIcon
                        icon={sortOrder === "asc" ? faSortDown : faSortUp}
                        style={{ marginLeft: "5px", color: "white" }}
                      />
                    )}
                  </th>
                  <th
                    style={{
                      width: "150px",
                      backgroundColor: "inherit",
                      color: "white",
                      cursor: "pointer",
                    }}
                    onClick={() => handleSort("oldestDocDate")}
                  >
                    Min({t("LastUpdate")})
                    {sortField === "oldestDocDate" && (
                      <FontAwesomeIcon
                        icon={sortOrder === "asc" ? faSortDown : faSortUp}
                        style={{ marginLeft: "5px", color: "white" }}
                      />
                    )}
                  </th>
                  <th
                    style={{ width: "150px", backgroundColor: "inherit" }}
                  ></th>
                </tr>
                <tr
                  className="style_tbody_tr_first"
                  style={{ backgroundColor: colorFilterAction }}
                >
                  <th style={{ backgroundColor: "inherit" }}>
                    <select
                      id="video-codage-model-filter"
                      className="form-select filter-select style_select"
                      value={filter.ModelId}
                      onChange={(e) =>
                        setFilter({ ...filter, ModelId: e.target.value })
                      }
                      style={{
                        width: "125px",
                        textAlign: "left",
                        height: "31px",
                        margin: "auto",
                      }}
                    >
                      <option value="">{t("Models")}</option>
                      {uniqueModels.map((model) => (
                        <option key={model} value={model}>
                          {model}
                        </option>
                      ))}
                    </select>
                  </th>
                  <th style={{ backgroundColor: "inherit" }}>
                    <select
                      id="video-codage-status-filter"
                      className="form-select filter-select style_select"
                      value={filter.statusFilter}
                      onChange={(e) =>
                        setFilter({ ...filter, statusFilter: e.target.value })
                      }
                      style={{
                        width: "125px",
                        textAlign: "left",
                        height: "31px",
                        margin: "auto",
                      }}
                    >
                      <option value="">{t("Status")}</option>
                      {allStatuses.map((status) => (
                        <option key={status} value={status}>
                          {status}
                        </option>
                      ))}
                    </select>
                  </th>
                  <th colSpan="3" style={{ backgroundColor: "inherit" }}></th>
                </tr>
              </thead>
              <tbody className="style_tbody">
                {filteredData.map((model) =>
                  model.docsByStatus.map((statusData) => (
                    <tr
                      key={`${model.ModelId}-${statusData.status}`}
                      className="style_tbody_tr_second"
                    >
                      <td>{model.ModelId}</td>
                      <td>{statusData.status}</td>
                      <td>{statusData.docsCount}</td>
                      <td>
                        {statusData.oldestDocDate
                          ? statusData.oldestDocDate.toLocaleDateString()
                          : t("No date")}
                      </td>
                      <td>
                        <button
                          className="btn btn-outline-primary"
                          onClick={() =>
                            VideoCodageButton(model.ModelId, statusData.status)
                          }
                          disabled={statusData.status === "in_review"}
                        >
                          VideoCoder
                        </button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>

      <Modal
        isOpen={modalIsOpen1}
        onRequestClose={closeModal1}
        contentLabel="Manual Review"
      >
        <h3>{currentDocName}</h3>
        <iframe
          src={currentReviewURL}
          style={{ width: "100%", height: "80vh" }}
          title="Manual Review Iframe"
        />
        <button onClick={closeModal1}>Close</button>
      </Modal>
      </div>
    </>
  );
};

export default ModelsVideoCodage;
